import { render, staticRenderFns } from "./Trunk.vue?vue&type=template&id=36a946a0&"
import script from "./Trunk.vue?vue&type=script&lang=js&"
export * from "./Trunk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports